import img1 from '/static/img/home/experiences/img1.png'
import img2 from '/static/img/home/experiences/img2.png'
const experiencesList = [
    {
        id:1,
        img:img1,
        title:'Customized travel services',
        desc:'From the moment you set off, every second of your journey will be filled with unique scenery.',
        btn:'Learn More'
    },
    {
        id:2,
        img:img2 ,
        title:'Niche travel destinations',
        desc:'Discover the most beautiful niche travel destinations in China and customize your trip with All Inclusive!',
        btn:"Discover More Journeys"
    }
]
export default {
    experiencesList
};